import { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

const PAGE_TITLE_CLASS_NAME = 'text-2xl font-semibold leading-8 tracking-tight';

const Card = (props: ComponentProps<'div'>) => {
  const { className, ...restProps } = props;

  return (
    <div
      data-slot="card"
      className={cn(
        'bg-card text-card-foreground flex flex-col gap-4 rounded-lg border py-4',
        className,
      )}
      {...restProps}
    />
  );
};

const CardHeader = (props: ComponentProps<'div'>) => {
  const { className, ...restProps } = props;

  return (
    <div
      data-slot="card-header"
      className={cn(
        'text-foreground @container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1 px-4 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-4',
        className,
      )}
      {...restProps}
    />
  );
};

const CardTitle = (props: ComponentProps<'div'>) => {
  const { className, ...restProps } = props;

  return (
    <div
      data-slot="card-title"
      className={cn('leading-none font-semibold', className)}
      {...restProps}
    />
  );
};

const CardDescription = (props: ComponentProps<'div'>) => {
  const { className, ...restProps } = props;

  return (
    <div
      data-slot="card-description"
      className={cn('text-muted-foreground text-sm', className)}
      {...restProps}
    />
  );
};

const CardAction = (props: ComponentProps<'div'>) => {
  const { className, ...restProps } = props;

  return (
    <div
      data-slot="card-action"
      className={cn(
        'col-start-2 row-span-2 row-start-1 self-start justify-self-end',
        className,
      )}
      {...restProps}
    />
  );
};

const CardContent = (props: ComponentProps<'div'>) => {
  const { className, ...restProps } = props;

  return (
    <div
      data-slot="card-content"
      className={cn('px-4', className)}
      {...restProps}
    />
  );
};

const CardFooter = (props: ComponentProps<'div'>) => {
  const { className, ...restProps } = props;

  return (
    <div
      data-slot="card-footer"
      className={cn('flex items-center px-4 [.border-t]:pt-4', className)}
      {...restProps}
    />
  );
};

export {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
  PAGE_TITLE_CLASS_NAME,
};
